import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

interface ExternalUserIdFilterProps {
  filterIndex: number;
}

/**
 * Renders a text input for filtering sessions by external user ID
 */
export const ExternalUserIdFilter = ({ filterIndex }: ExternalUserIdFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const externalUserId = useWatch({ control, name: `filters.${filterIndex}.externalUserId` }) || '';

  const handleExternalUserIdChange = (value: string) => {
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, externalUserId: value });
  };

  return (
    <Input
      id={`external-user-id-${filterIndex}`}
      type="text"
      placeholder={t('analytics.filters.externalUserIdPlaceholder')}
      value={externalUserId}
      onChange={(e) => handleExternalUserIdChange(e.target.value)}
      className="w-full"
    />
  );
};
